import { render } from "./WriteMessagePlusIcon.vue?vue&type=template&id=6bd599e9"
import script from "./WriteMessagePlusIcon.vue?vue&type=script&lang=js"
export * from "./WriteMessagePlusIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__